export default __webpack_public_path__ + "static/media/DataDrivenReport.bdd4593e.svg";